/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the challenge is being resolved.
 */
export const ResolveChallengeFormResolutionType = {
  RoleAssigned: "role_assigned",
  Dismissed: "dismissed",
} as const;
/**
 * How the challenge is being resolved.
 */
export type ResolveChallengeFormResolutionType = ClosedEnum<
  typeof ResolveChallengeFormResolutionType
>;

export type ResolveChallengeForm = {
  /**
   * IDs of the challenges in ClickHouse to resolve.
   */
  challengeIds: Array<string>;
  /**
   * Principal that was denied.
   */
  principalUrn: string;
  /**
   * How the challenge is being resolved.
   */
  resolutionType: ResolveChallengeFormResolutionType;
  /**
   * Resource ID from the challenge.
   */
  resourceId?: string | undefined;
  /**
   * Resource kind from the challenge.
   */
  resourceKind?: string | undefined;
  /**
   * Confirms the administrator reviewed and accepts every permission granted by the complete role. Must be true when resolution_type=role_assigned.
   */
  roleAssignmentConfirmed?: boolean | undefined;
  /**
   * Custom role slug to add to the denied user before resolving (required when resolution_type=role_assigned).
   */
  roleSlug?: string | undefined;
  /**
   * Scope that was denied.
   */
  scope: string;
};

/** @internal */
export const ResolveChallengeFormResolutionType$outboundSchema: z.ZodMiniEnum<
  typeof ResolveChallengeFormResolutionType
> = z.enum(ResolveChallengeFormResolutionType);

/** @internal */
export type ResolveChallengeForm$Outbound = {
  challenge_ids: Array<string>;
  principal_urn: string;
  resolution_type: string;
  resource_id?: string | undefined;
  resource_kind?: string | undefined;
  role_assignment_confirmed?: boolean | undefined;
  role_slug?: string | undefined;
  scope: string;
};

/** @internal */
export const ResolveChallengeForm$outboundSchema: z.ZodMiniType<
  ResolveChallengeForm$Outbound,
  ResolveChallengeForm
> = z.pipe(
  z.object({
    challengeIds: z.array(z.string()),
    principalUrn: z.string(),
    resolutionType: ResolveChallengeFormResolutionType$outboundSchema,
    resourceId: z.optional(z.string()),
    resourceKind: z.optional(z.string()),
    roleAssignmentConfirmed: z.optional(z.boolean()),
    roleSlug: z.optional(z.string()),
    scope: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      challengeIds: "challenge_ids",
      principalUrn: "principal_urn",
      resolutionType: "resolution_type",
      resourceId: "resource_id",
      resourceKind: "resource_kind",
      roleAssignmentConfirmed: "role_assignment_confirmed",
      roleSlug: "role_slug",
    });
  }),
);

export function resolveChallengeFormToJSON(
  resolveChallengeForm: ResolveChallengeForm,
): string {
  return JSON.stringify(
    ResolveChallengeForm$outboundSchema.parse(resolveChallengeForm),
  );
}
